import React from "react";
import * as Constants from "../../constants/urls";

const Tr = ({ id, search, link, hasResult, userId }) => {
    const checkLink = (link) => {
        if (link == null) return;
        if (!link.startsWith(Constants.siteUrl))
            link = Constants.siteUrl + "/shop/product/category/" + link;
        return link;
    };

    return (
        <tr>
            <td>
                <span>{id}</span>
            </td>
            <td>
                <span>{search}</span>
            </td>
            <td>
                <a rel="noreferrer" target="_blank" href={checkLink(link)}>
                    <span>{checkLink(link)}</span>
                </a>
            </td>
            <td>
                <span>{userId}</span>
            </td>

            <td>
                <span>
                    <div
                        className={`badge badge-${
                            hasResult ? "success" : "danger"
                        }`}
                    >
                        {hasResult ? "بله" : "خیر"}
                    </div>
                </span>
            </td>
        </tr>
    );
};
export default Tr;
